import { render, staticRenderFns } from "./TodoFilters.vue?vue&type=template&id=79f0badf&"
import script from "./TodoFilters.vue?vue&type=script&lang=js&"
export * from "./TodoFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports